import React from "react";
import PropTypes from "prop-types";

import { FormFieldList } from "scenes/Hubly/components/Workspace/components/FormFieldList/FormFieldList";

import { useTaskForm } from "./hooks";

export default function TaskForm({ task, onUpdate, onClose }) {
  const {
    fields,
    isCreatingFormField,
    isUpdatingForm,
    isDeletingForm,
    createFormField,
    updateForm,
    deleteForm,
    updateFieldOrder,
  } = useTaskForm(task, onUpdate);

  return (
    <FormFieldList
      formName={task?.form?.name}
      initialAddMode={Boolean(!task?.form?.id)}
      isCreatingField={isCreatingFormField}
      isUpdatingForm={isUpdatingForm}
      isDeletingForm={isDeletingForm}
      fields={fields}
      onAddField={(field, placeBeforeItemId, formName) => {
        return createFormField(task.id, field, placeBeforeItemId, formName);
      }}
      onEditField={(f, field) => {
        return f.update(field);
      }}
      onUpdateForm={(formName) => {
        return updateForm(task?.form?.id, formName);
      }}
      onDeleteForm={async () => {
        if (task?.form?.id) await deleteForm(task?.form?.id);

        onClose();
      }}
      onDeleteField={async (f) => {
        await f.delete();

        if (task?.form.fields.length === 1) onClose();
        onUpdate({
          ...task,
          form:
            task?.form.fields.length === 1
              ? null
              : {
                  ...task.form,
                  fields: task.form.fields.filter((field) => {
                    return field.id !== f.id;
                  }),
                },
        });
      }}
      onClose={onClose}
      onFieldReordered={updateFieldOrder}
    />
  );
}

TaskForm.propTypes = {
  task: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
